module.exports = __webpack_public_path__ + "img/40-3-n.7b0e3992.png";